import React, { createContext, useContext, useReducer } from "react";
import { ACTION_TYPES, HomeReducer, HomeState } from "./home-reducer";
import { IApplicationData } from "models/application-data";

const HomeContext = createContext<HomeState | undefined>(undefined);
const HomeContextDispatchContext = createContext({} as any);

const HomeProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(HomeReducer, { } as HomeState);

    return (
        <HomeContext.Provider value={state}>
            <HomeContextDispatchContext.Provider value={dispatch}>
                {children}
            </HomeContextDispatchContext.Provider>
        </HomeContext.Provider>
    );
}

const useHomeState = () => {
    const context = useContext(HomeContext);
    if (context === undefined) {
        throw new Error('useHomeState must be used within a HomeProvider');
    }
    return context;
}

const useHomeDispatch = () => {
    const context = useContext(HomeContextDispatchContext);
    if (context === undefined) {
        throw new Error('useHomeDispatch must be used within a HomeProvider');
    }
    return context;
}

export { HomeProvider, useHomeState, useHomeDispatch, ACTION_TYPES };